import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "../../hooks";
import {fetchUser, selectUser} from "../../actions/userSlice";
import {UserDetails} from "../../actions/api";
import {Spin, Checkbox, Form} from 'antd';
import styles from "./styles.module.scss";
import { EditMyAccount } from "./EditMyAccount";

const MyAccount = () => {

    const dispatch = useAppDispatch()
    const user = useAppSelector(selectUser) as UserDetails
    const [form] = Form.useForm()

    const [edit, setEdit] = useState<boolean>(false)
    const cancelEdit = () => {
        setEdit(false)
        form.resetFields()
    }

    useEffect(() => {
        if (user === undefined) {
            dispatch(fetchUser())
        }
    }, [user, dispatch])

    if (user) {
        return <div className={styles.viewMyAccount}>
            <div className={styles.header}>
                <div className={styles.title}>
                    Account Details
                    <div className={styles.icon}>
                        Edit <Checkbox checked={edit} onChange={() => edit ? cancelEdit() : setEdit(true)}/>
                    </div>
                </div>
            </div>
            <EditMyAccount form={form} user={user} edit={edit} onSave={() => setEdit(false)} onCancelEdit={cancelEdit}/>
        </div>
    } else {
        return <Spin tip="Loading..."/>
    }

}

export default MyAccount